function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledGlobeDesktopHomepageFirstFoldComponent } from "./globe-desktop-homepage-first-fold-component.scss";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
class GlobeDesktopHomepageFirstFoldComponent extends PureComponent {
    render() {
        const { height } = this.props;
        return /*#__PURE__*/ _jsx(StyledGlobeDesktopHomepageFirstFoldComponent, {
            className: "globe-desktop-homepage-first-fold-component",
            style: {
                height
            },
            children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread({
                contentClassName: "globe-text-and-asset-content"
            }, this.props))
        });
    }
}
export { GlobeDesktopHomepageFirstFoldComponent as default };
